module.exports = __webpack_public_path__ + "img/imgrewardbtinactive.805b4e7a.png";